import { useState, useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';

import type { IMockIdable, IProjectBaseDTO } from '@gp/types/global';

interface IDPSReportModuleRecord extends IMockIdable, IProjectBaseDTO {}

export default function useDPSReportModule<T extends IDPSReportModuleRecord>(props: {
  buildRecord: () => T;
  value: T[];
  onChange?: (payload: T[]) => void;
}) {
  const { buildRecord, value, onChange } = props;

  const [records, setRecords] = useState<T[]>([]);

  const handleAdd = useMemoizedFn(() => {
    const recordNew = buildRecord();
    const recordsTmp = [...records, recordNew];
    setRecords(recordsTmp);
  });

  const handleDelete = useMemoizedFn((selection: string[]) => {
    const recordsTmp = records?.filter((record) => {
      const recordMockId = record?.mock_id;
      return recordMockId && !selection?.includes(recordMockId);
    });
    onChange?.(recordsTmp);
  });

  useEffect(() => {
    if (!Array.isArray(value)) {
      setRecords([]);
      return;
    }

    setRecords(value);
  }, [value]);

  return {
    records,
    setRecords,
    onAdd: handleAdd,
    onDelete: handleDelete,
  };
}
